import { useAuth } from '@/composables/useAuth';
import { USER_ACTIVITY_EVENTS } from '@/utils/constants';
import SendCommon from "@/services/IframeBridge/common/outbound.ts";

const POST_MESSAGE_INTERVAL = 30000; // 30 seconds
let lastPostMessageTime = 0;
let isTrackingActive = false;

export const useHeartBeatTracker = () => {
    const { isLoggedIn } = useAuth();

    const handleUserActivityAndPost = () => {
        if (!isLoggedIn.value) return;

        const now = Date.now();
        if (lastPostMessageTime === 0 || (now - lastPostMessageTime > POST_MESSAGE_INTERVAL)) {
            lastPostMessageTime = now;
            SendCommon.userHeartBeat({ active: true }, { sendToAllIframes: true });
        }
    };

    const startPostMessageTracker = () => {
        if (isTrackingActive || !isLoggedIn.value) return;
        isTrackingActive = true;

        USER_ACTIVITY_EVENTS.forEach(name => {
            window.addEventListener(name, handleUserActivityAndPost, { passive: true });
        });
        handleUserActivityAndPost();
    };

    const stopPostMessageTracker = () => {
        if (!isTrackingActive) return;
        isTrackingActive = false;

        USER_ACTIVITY_EVENTS.forEach(name => {
            window.removeEventListener(name, handleUserActivityAndPost);
        });

        lastPostMessageTime = 0;
    };

    return {
        startPostMessageTracker,
        stopPostMessageTracker
    };
};